import React from "react";
import { PageHeader, ModulePlaceholder } from "@/components/ds";

export default function ModulePage({ title, description }: { title: string; description: string }) {
  return (
    <div data-testid={`page-${title.toLowerCase().replace(/\s+/g, "-")}`}>
      <PageHeader title={title} description={description} />
      <ModulePlaceholder module={title} />
    </div>
  );
}
